<script>
    import ShopIndex from './index'
    export default ShopIndex
</script>
